import { z } from "zod/v4";

/**
 * Schema for new site page search parameters
 */
export const NewSiteSearchSchema = z.object({
	url: z.string().optional(),
	showOptions: z.boolean().optional(),
	siteId: z.string().optional(), // Site ID when site is already created
	discoveryId: z.string().optional(), // Discovery ID when URLs already discovered
});

export type NewSiteSearch = z.infer<typeof NewSiteSearchSchema>;

/**
 * Schema for site options page search parameters
 */
export const OptionsSearchSchema = z.object({
	url: z.string().min(1),
});

export type OptionsSearch = z.infer<typeof OptionsSearchSchema>;

/**
 * Schema for site detail page search parameters
 */
export const SiteDetailSearchSchema = z.object({
	jobId: z.string().optional(),
	tab: z.enum(["overview", "content"]).optional(),
});

export type SiteDetailSearch = z.infer<typeof SiteDetailSearchSchema>;

/**
 * Schema for generation status page parameters
 */
export const GenerationStatusParamsSchema = z.object({
	jobId: z.string(),
});

export type GenerationStatusParams = z.infer<
	typeof GenerationStatusParamsSchema
>;
